import { trackEvent } from './track-event'

type Props = {
  origin: 'list' | 'pdp'
  itemName: string
  itemId: string
  type: string
}

export function trackAddToWishlist({ origin, itemName, itemId, type }: Props) {
  trackEvent({
    event: 'add_to_wishlist',
    event_name: 'user_interaction',
    action: 'click - add_to_wishlist',
    wishlist_location: origin,
    item: itemName,
    item_id: itemId,
    type,
  })
}
